import { render } from "./XTimer.vue?vue&type=template&id=b70f2b80&scoped=true"
import script from "./XTimer.vue?vue&type=script&lang=js"
export * from "./XTimer.vue?vue&type=script&lang=js"

import "./XTimer.vue?vue&type=style&index=0&id=b70f2b80&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b70f2b80"]])

export default __exports__